import { CanonicalInterval } from 'src/types';
import { usePaymentControlState } from 'src/hooks';
import { usePaymentControlActions } from 'src/hooks';
import { Button } from 'src/v2/commonComponents/Button';
import { capitalizeEachFirstLetter } from 'src/utils';
import classNames from 'classnames';
import styles from './PeriodSwitch.module.scss';

const SUPPORTED_PERIODS = [
  CanonicalInterval.MONTHLY,
  CanonicalInterval.ANNUALLY,
];

export const PeriodSwitch = () => {
  const { selectedPeriod } = usePaymentControlState();
  const { onSetSelectedPeriod } = usePaymentControlActions();

  const handlePeriodChange = ({
    currentTarget,
  }: React.MouseEvent<HTMLButtonElement>) => {
    const value = currentTarget.name as CanonicalInterval;
    onSetSelectedPeriod(value);
  };

  return (
    <div className={styles.root}>
      {SUPPORTED_PERIODS.map((period) => (
        <Button
          key={period}
          className={classNames(styles.button, {
            [styles.active]: selectedPeriod === period,
          })}
          color="secondary"
          size="small"
          name={period}
          onClick={handlePeriodChange}
        >
          {capitalizeEachFirstLetter(period)}
          {period === CanonicalInterval.ANNUALLY && (
            <span className={styles.accent}> (2 Month Off)</span>
          )}
        </Button>
      ))}
    </div>
  );
};
